import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import LocalFireDepartmentIcon from '@material-ui/icons/LocalFireDepartment';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import Container from 'common/Container';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';

const FIRE_ORANGE = '#ff6f00';
const FIRE_AMBER = '#ffb300';
const CARD_BG = 'rgba(32, 8, 8, 0.9)';
const PAGE_BG = [
  'radial-gradient(ellipse 120% 64% at 50% -10%, rgba(255,111,0,0.28) 0%, transparent 52%)',
  'radial-gradient(ellipse 72% 58% at 8% 95%, rgba(183,28,28,0.34) 0%, transparent 54%)',
  'linear-gradient(130deg, rgba(22,3,3,1) 0%, rgba(56,10,10,0.98) 44%, rgba(102,22,12,0.95) 74%, rgba(255,152,0,0.32) 100%)',
].join(', ');

const sectionSx = {
  py: { xs: 5, md: 7 },
  borderBottom: '1px solid rgba(255,179,0,0.2)',
};

const bulletSx = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1,
  mb: 1,
  color: 'rgba(255,245,235,0.92)',
};

const quoteSx = {
  p: { xs: 2, md: 2.5 },
  borderRadius: 2,
  border: '1px solid rgba(255,179,0,0.35)',
  bgcolor: 'rgba(255,152,0,0.1)',
  color: '#fff3e0',
  fontStyle: 'italic',
  fontWeight: 600,
};

function LandingMediaKitSVP() {
  return (
    <Box
      sx={{
        color: '#fff8f0',
        minHeight: '100vh',
        bgcolor: '#120404',
        backgroundImage: PAGE_BG,
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Container>
        <Box sx={{ ...sectionSx, pt: { xs: 7, md: 9 }, textAlign: 'center' }}>
          <Box
            component="img"
            src="/images/logos/logo_white.PNG"
            alt="TNO Network"
            sx={{
              display: 'block',
              mx: 'auto',
              mb: 2.1,
              width: { xs: 210, md: 300 },
              maxWidth: '72vw',
              height: 'auto',
              objectFit: 'contain',
            }}
          />
          <Typography sx={{ color: FIRE_AMBER, fontWeight: 800, letterSpacing: 3, mb: 1.5 }} variant="overline">
            Propuesta Maestra de Alianza Estratégica
          </Typography>
          <Typography component="h1" sx={{ fontWeight: 900, fontSize: { xs: '2rem', md: '3rem' }, lineHeight: 1.12, mb: 1.5 }}>
            SVP x TNO Network
          </Typography>
          <Typography sx={{ color: '#ffd180', fontWeight: 700, fontSize: { xs: '1.08rem', md: '1.28rem' }, mb: 2 }}>
            "La Evolución del Fuego: Legado, Autoridad y Negocio"
          </Typography>
          <Typography sx={{ color: 'rgba(255,230,190,0.95)', fontStyle: 'italic', fontWeight: 700, mb: 2 }}>
            "SVP x TNO Network: La Enciclopedia del Asado. El conocimiento de los campeones, a un clic."
          </Typography>
          <Typography sx={{ maxWidth: 940, mx: 'auto', color: 'rgba(255,245,235,0.88)', lineHeight: 1.7, fontSize: { xs: '1.03rem', md: '1.14rem' } }}>
            Esta es la Propuesta Maestra de Alianza Estratégica entre TNO Network y la Sociedad Venezolana de Parrilleros (SVP). El objetivo es
            convertir su conocimiento técnico en el activo digital más potente de la gastronomía nacional.
          </Typography>
          <Box
            component="img"
            src="/images/logos/svp.png"
            alt="SVP"
            sx={{
              display: 'block',
              mx: 'auto',
              mt: 2.2,
              mb: 0.6,
              width: { xs: 130, md: 170 },
              maxWidth: '42vw',
              height: 'auto',
              objectFit: 'contain',
            }}
          />
        </Box>

        <Box sx={sectionSx}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 1 }}>
            <MenuBookIcon sx={{ color: FIRE_ORANGE }} />
            <Typography component="h2" sx={{ fontWeight: 800, fontSize: { xs: '1.45rem', md: '2rem' } }}>
              1. Proyecto Insignia: Enciclopedia Digital del Asado
            </Typography>
          </Box>
          <Typography sx={{ color: 'rgba(255,245,235,0.88)', mb: 2.5, lineHeight: 1.65 }}>
            Construimos la "Biblia de las Brasas" en Venezuela: TNO aporta tecnología y distribución; la SVP aporta ADN de campeones mundiales.
          </Typography>
          <Typography sx={{ color: '#ffd180', fontStyle: 'italic', fontWeight: 700, mb: 2 }}>
            "La técnica la ponen ellos, la historia la escribimos nosotros."
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 2.5, borderRadius: 2, bgcolor: CARD_BG, border: '1px solid rgba(255,111,0,0.35)', height: '100%' }}>
                <Typography sx={{ color: FIRE_AMBER, fontWeight: 800, mb: 1.2 }}>En TNO Digest (SEO & Google)</Typography>
                <Typography sx={{ lineHeight: 1.6, color: 'rgba(255,245,235,0.88)' }}>
                  Sección fija e indexada con "Tomos" técnicos: cortes, técnicas y secretos parrilleros. Objetivo: dominar búsquedas como "asado negro
                  a la brasa" y "ahumado Texas en Caracas".
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 2.5, borderRadius: 2, bgcolor: CARD_BG, border: '1px solid rgba(255,179,0,0.4)', height: '100%' }}>
                <Typography sx={{ color: FIRE_AMBER, fontWeight: 800, mb: 1.2 }}>En Radio Visual (Video-Diccionario)</Typography>
                <Typography sx={{ lineHeight: 1.6, color: 'rgba(255,245,235,0.88)' }}>
                  Cápsulas de 60 segundos: "Enciclopedia del Asado: Tomo [X]". Formato estético, técnico y rápido con Maestros explicando la ciencia
                  detrás del fuego.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box sx={sectionSx}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 1 }}>
            <PlayCircleOutlineIcon sx={{ color: FIRE_ORANGE }} />
            <Typography component="h2" sx={{ fontWeight: 800, fontSize: { xs: '1.45rem', md: '2rem' } }}>
              2. Ecosistema de Contenido y Rotativa
            </Typography>
          </Box>
          <Grid container spacing={2}>
            {[
              {
                title: 'El Veredicto del Asador',
                subtitle: 'Micros en rotativa',
                text: '12 spots diarios distribuidos en señal 24/7 con tips rápidos de autoridad: manejo de cuchillos, elección de carbón y tiempos de reposo.',
                Icon: WhatshotIcon,
              },
              {
                title: 'Crónicas de Brasa',
                subtitle: 'Streaming & On-Demand',
                text: 'Entrevistas de fondo con protagonistas del mundial de México y fundadores de la sociedad, documentando la historia de la SVP para la posteridad.',
                Icon: LocalFireDepartmentIcon,
              },
              {
                title: 'Certificación SVP',
                subtitle: 'Validación de terceros',
                text: 'Espacios donde la sociedad valida productos de terceros (carnes, equipos y condimentos). TNO comercializa y la SVP certifica.',
                Icon: VerifiedUserIcon,
              },
            ].map(({ title, subtitle, text, Icon }) => (
              <Grid item xs={12} md={4} key={title}>
                <Box sx={{ p: 2.4, borderRadius: 2, bgcolor: CARD_BG, border: '1px solid rgba(255,111,0,0.35)', height: '100%' }}>
                  <Icon sx={{ color: FIRE_AMBER, mb: 1 }} />
                  <Typography sx={{ fontWeight: 800, mb: 0.5 }}>{title}</Typography>
                  <Typography sx={{ color: FIRE_ORANGE, fontWeight: 700, mb: 1, fontSize: '0.95rem' }}>{subtitle}</Typography>
                  <Typography sx={{ color: 'rgba(255,245,235,0.88)', lineHeight: 1.55 }}>{text}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={sectionSx}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 1 }}>
            <BusinessCenterIcon sx={{ color: FIRE_ORANGE }} />
            <Typography component="h2" sx={{ fontWeight: 800, fontSize: { xs: '1.45rem', md: '2rem' } }}>
              3. Alianzas Tripartitas: El Círculo del Negocio
            </Typography>
          </Box>
          <Box sx={bulletSx}>
            <RestaurantIcon sx={{ color: FIRE_AMBER, fontSize: 20, mt: '2px' }} />
            <Typography>
              Espacios de colaboración abiertos para marcas relacionadas con el ecosistema parrillero y gastronómico: carnes, equipos, carbón,
              condimentos, higiene, accesorios y servicios especializados.
            </Typography>
          </Box>
          <Box sx={bulletSx}>
            <LocalFireDepartmentIcon sx={{ color: FIRE_AMBER, fontSize: 20, mt: '2px' }} />
            <Typography>
              La propuesta mantiene una estructura flexible para integrar nuevos aliados estratégicos según objetivos comerciales y afinidad con la
              línea editorial SVP x TNO.
            </Typography>
          </Box>
        </Box>

        <Box sx={sectionSx}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 1 }}>
            <EmojiObjectsIcon sx={{ color: FIRE_ORANGE }} />
            <Typography component="h2" sx={{ fontWeight: 800, fontSize: { xs: '1.45rem', md: '2rem' } }}>
              4. Estructura de Inversión (Modelo Ganar-Ganar)
            </Typography>
          </Box>
          <Typography sx={{ color: 'rgba(255,245,235,0.88)', lineHeight: 1.65, mb: 2 }}>
            Para mantener la llama encendida y consolidar esta alianza estratégica:
          </Typography>
          <Box sx={{ mb: 2.5, borderRadius: 2, overflow: 'hidden', border: '1px solid rgba(255,179,0,0.35)' }}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1.7fr 1fr', md: '2fr 1fr' },
                bgcolor: 'rgba(255,179,0,0.18)',
                px: 2,
                py: 1.4,
              }}
            >
              <Typography sx={{ fontWeight: 800, color: '#fff6e8' }}>Producto / Entregable mensual</Typography>
              <Typography sx={{ fontWeight: 800, color: '#fff6e8', textAlign: 'right' }}>Inversión (USD)</Typography>
            </Box>
            {[
              { product: 'TNO Digest SEO: 4 tomos editoriales de la Enciclopedia del Asado', price: '$80' },
              { product: 'Radio Visual: 8 cápsulas de 60 segundos "Tomo [X]"', price: '$140' },
              { product: 'Rotativa 24/7: paquete de micros "El Veredicto del Asador"', price: '$90' },
              { product: 'Gestión, edición, distribución y mantenimiento de la sección SVP', price: '$50' },
            ].map((row, idx) => (
              <Box
                key={row.product}
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1.7fr 1fr', md: '2fr 1fr' },
                  px: 2,
                  py: 1.35,
                  bgcolor: idx % 2 === 0 ? 'rgba(255,255,255,0.03)' : CARD_BG,
                  borderTop: idx === 0 ? 'none' : '1px solid rgba(255,179,0,0.16)',
                }}
              >
                <Typography sx={{ color: 'rgba(255,245,235,0.92)', lineHeight: 1.5 }}>{row.product}</Typography>
                <Typography sx={{ color: '#fff', fontWeight: 800, textAlign: 'right' }}>{row.price}</Typography>
              </Box>
            ))}
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1.7fr 1fr', md: '2fr 1fr' },
                px: 2,
                py: 1.5,
                bgcolor: 'rgba(255,111,0,0.18)',
                borderTop: '1px solid rgba(255,179,0,0.3)',
              }}
            >
              <Typography sx={{ color: '#fff6e8', fontWeight: 900 }}>Total mensual</Typography>
              <Typography sx={{ color: '#fff', fontWeight: 900, textAlign: 'right' }}>$360</Typography>
            </Box>
          </Box>
          <Box sx={quoteSx}>
            Beneficio adicional: TNO Network actuará como Media Partner para los torneos nacionales e internacionales de la SVP, garantizando
            cobertura de prensa y difusión masiva; este beneficio está incluido en la propuesta, contemplando únicamente un costo promocional
            adicional asociado a logística cuando aplique.
          </Box>
          <PriceVatDisclaimer sx={{ mt: 2, color: 'rgba(255,255,255,0.75)' }} />
        </Box>

        <Box sx={{ ...sectionSx, borderBottom: 'none', pb: { xs: 8, md: 10 } }}>
          <Typography component="h2" sx={{ fontWeight: 800, fontSize: { xs: '1.45rem', md: '2rem' }, mb: 1.5 }}>
            6. Por qué esta alianza es el siguiente paso lógico
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            {[
              {
                title: 'Legado',
                text: 'El conocimiento de la SVP deja de ser efímero y se convierte en una biblioteca digital eterna.',
              },
              {
                title: 'Monetización',
                text: 'La SVP puede atraer patrocinadores de mayor nivel al ofrecer una plataforma de medios profesional (Radio Visual + SEO).',
              },
              {
                title: 'Autoridad',
                text: 'Separa a los Maestros Parrilleros de los aficionados, con el respaldo de la señal multiplataforma más innovadora del país.',
              },
            ].map((item) => (
              <Grid item xs={12} md={4} key={item.title}>
                <Box sx={{ p: 2.4, borderRadius: 2, bgcolor: CARD_BG, border: '1px solid rgba(255,111,0,0.35)', height: '100%' }}>
                  <Typography sx={{ color: FIRE_AMBER, fontWeight: 800, mb: 1 }}>{item.title}</Typography>
                  <Typography sx={{ color: 'rgba(255,245,235,0.88)', lineHeight: 1.58 }}>{item.text}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
          <Typography sx={{ textAlign: 'center', color: '#ffd180', fontStyle: 'italic', fontWeight: 700, mb: 2 }}>
            "No es solo parrilla, es ciencia. Bienvenidos a la Evolución del Fuego."
          </Typography>
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ color: FIRE_AMBER, fontWeight: 800, letterSpacing: 2, mb: 1 }} variant="overline">
              TNO Network 2026 | The Content Evolution
            </Typography>
            <Typography sx={{ maxWidth: 920, mx: 'auto', fontSize: { xs: '1.07rem', md: '1.2rem' }, lineHeight: 1.62 }}>
              Presidente de la SVP, Ing. Edward Higuera: es momento de que el fuego de sus brasas se convierta en luz para toda la audiencia digital.
              <br />
              <strong>¿Arrancamos el Tomo 1 de la Enciclopedia esta misma semana?</strong>
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default LandingMediaKitSVP;
